module.exports = __webpack_public_path__ + "static/media/md-pizza.f959f98f.svg";